import { useCallback, useMemo } from "react";
import { useTranslation } from "../hooks";
export default function useTranslatedVoiceSampleScript() {
    const { t } = useTranslation();
    const translatedByCode = useMemo(() => ({
        ar: t("voice:form.sample.script.ar"),
        de: t("voice:form.sample.script.de"),
        en: t("voice:form.sample.script.en"),
        es: t("voice:form.sample.script.es"),
        fr: t("voice:form.sample.script.fr"),
        he: t("voice:form.sample.script.he"),
        hi: t("voice:form.sample.script.hi"),
        it: t("voice:form.sample.script.it"),
        ja: t("voice:form.sample.script.ja"),
        ko: t("voice:form.sample.script.ko"),
        nl: t("voice:form.sample.script.nl"),
        pl: t("voice:form.sample.script.pl"),
        pt: t("voice:form.sample.script.pt"),
        ru: t("voice:form.sample.script.ru"),
        tr: t("voice:form.sample.script.tr"),
        zh: t("voice:form.sample.script.zh"),
        "zh-cn": t("voice:form.sample.script.zh-cn"),
        "zh-hans": t("voice:form.sample.script.zh-hans"),
        "zh-hant": t("voice:form.sample.script.zh-hant"),
        "zh-tw": t("voice:form.sample.script.zh-tw"),
    }), [t]);
    const getTranslatedVoiceSampleScript = useCallback((code) => {
        if (!code)
            return "";
        return translatedByCode[code] ?? code;
    }, [translatedByCode]);
    return { getTranslatedVoiceSampleScript };
}
